<template>
<div>
  <transition name="fade">
    <div v-if="!dataLoaded" class="rainbow-spinner">
      <md-progress-spinner class="spinner" :md-diameter="40" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
    </div>
  </transition>
  <transition name="fade">
    <div class="md-layout" v-if="dataLoaded">
      <!-- Filters -->
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-warning">
            <div class="card-text">
              <h4 class="title">Rainbow - Tags</h4>
              <p class="category">View and manage tags</p>
            </div>
            <div class="pull-right">
              <md-button
                class="md-primary md-just-icon md-round mt-10"
              >
                <md-icon>add</md-icon>
              </md-button>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-20">
                <md-field>
                  <label>Search by name</label>
                  <md-input
                    v-model="searchQuery"
                    type="search"
                    clearable
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-20">
                <md-field>
                  <label for="type">Type</label>
                  <md-select v-model="filters.type" name="type">
                    <md-option value="all">All</md-option>
                    <md-option value="categories">Tags</md-option>
                    <md-option value="keywords">Keywords</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-20">
                <md-field>
                  <label for="sortBy">Sort by</label>
                  <md-select v-model="filters.sortBy" name="sortBy" id="sortBy">
                    <md-option value="name">Name</md-option>
                    <md-option value="products">Number of products</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-20">
                <md-field class="md-size-20">
                  <label for="sortBy">Sort Order</label>
                  <md-select
                    v-model="filters.sortOrder"
                    name="sortOrder"
                    id="sortOrder"
                  >
                    <md-option value="asc">Ascending</md-option>
                    <md-option value="desc">Descending</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-20">
                <md-field>
                  <label for="perPage">Per page</label>
                  <md-select v-model="filters.perPage" name="perPage">
                    <md-option
                      v-for="item in perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                      {{ item }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-size-50 mx-auto" style="height:5px;">
                <md-progress-bar v-if="searching" class="md-accent" md-mode="query"></md-progress-bar>
              </div>
            </div>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-primary"
              v-model="filters.currentPage"
              :per-page="filters.perPage"
              :total="total"
            >
            </pagination>
          </md-card-actions>
        </md-card>
      </div>
      <!-- Categories -->
      <div class="md-layout-item md-xsmall-size-80 md-small-size-80 md-medium-size-70 md-large-size-65 md-xlarge-size-50 mx-auto">
        <md-card v-for="item in categories" :key="item.KeywordId" style="margin:5px 0;">
          <md-card-content class="md-card-content p-0">
            <div class="md-layout">
              <div class="md-layout-item md-size-70 hlh-50">
                <b>{{item.KeywordId}}.</b> {{ item.Keyword }}
              </div>
              <div class="md-layout-item md-size-10">
                <h6 class="m-0 p-0 hlh-50">{{item.Count}}</h6>
              </div>
              <div class="md-layout-item">
                <md-button
                  @click="promptDeleteKeyword(item)"
                  class="md-danger md-simple md-sm md-round md-just-icon pull-right">
                  <md-icon>delete_sweep</md-icon>
                </md-button>
                <md-button
                  @click="promptEditKeyword(item)"
                  class="md-warning md-simple md-sm md-round md-just-icon pull-right">
                  <md-icon>edit</md-icon>
                </md-button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </transition>

  <modal v-if="deleteModalOpened" @close="hideDeleteModal">
    <template slot="header">
      <md-button
        class="md-simple md-just-icon md-round modal-default-button"
        @click="hideDeleteModal"
      >
        <md-icon>clear</md-icon>
      </md-button>
    </template>

    <template slot="body">
      <p>Are you sure you want to delete the keyword?</p>
    </template>

    <template slot="footer">
      <md-button class="md-simple" :disabled="deleting" @click="hideDeleteModal"
        >Never Mind</md-button
      >
      <md-button class="md-success md-simple" @click="deleteKeyword()">
        <span v-if="!deleting">Yes</span>
        <md-progress-spinner v-else class="spinner" :md-diameter="20" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
      </md-button>
    </template>
  </modal>

  <modal v-if="editModalOpened" @close="hideEditModal" :closeOnBackdrop="false">
    <template slot="header">
      <md-button
        class="md-simple md-just-icon md-round modal-default-button"
        @click="hideEditModal"
      >
        <md-icon>clear</md-icon>
      </md-button>
    </template>

    <template slot="body">
      <md-field>
        <label>Enter new keyword name</label>
        <md-input v-model="keywordName" type="text"></md-input>
      </md-field>
    </template>

    <template slot="footer">
      <md-button class="md-simple" :disabled="saving" @click="hideEditModal"
        >Never Mind</md-button
      >
      <md-button class="md-success md-simple" @click="editKeyword()" :disabled="!canSave">
        <span v-if="!saving">Yes</span>
        <md-progress-spinner v-else class="spinner" :md-diameter="20" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
      </md-button>
    </template>
  </modal>
</div>
</template>

<style>
.keyword {
  margin: 0 5px 5px 0;
}
.mt-10 {
  margin-top: 10px;
}
</style>

<script>
import axios from "axios";
import { Pagination } from "@/components";
import { Modal } from "@/components";

import {
  StatsCard,
  AnimatedNumber
} from "@/components";

export default {
  components: {
    Pagination,
    Modal
  },
  data() {
    return {
      categories: [],
      dataLoaded: false,
      searching: false,
      deleteModalOpened: false,
      editModalOpened: false,
      deleting: false,
      saving: false,
      keywordToDelete: null,
      searchTimeout: null,
      keywordName: '',
      total: 0,
      filters: {
        sortBy: "name",
        sortOrder: "asc",
        perPage: 64,
        currentPage: 1,
        type: "all"
      },
      perPageOptions: [4, 8, 16, 32, 64, 128, 256, 512, 1024],
      searchQuery: "",
      searchedData: []
    }
  },
  mounted() {
    this.searchKeywords();
  },
  computed: {
    sortBy() {
      return this.filters.sortBy;
    },
    sortOrder() {
      return this.filters.sortOrder;
    },
    type() {
      return this.filters.type;
    },
    currentPage() {
      return this.filters.currentPage;
    },
    perPage() {
      return this.filters.perPage;
    },
    to() {
      let highBound = this.from + this.filters.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.filters.perPage * (this.filters.currentPage - 1);
    },
    queriedData() {
      return this.searchedData;
    },
    canSave () {
      return this.keywordName && this.keywordName.length > 0
    }
  },
  methods: {
    search() {
      alert();
    },
    searchKeywords () {
      this.searching = true
      this.filters.filter = this.searchQuery && this.searchQuery.length ? this.searchQuery : null;
      
      let promise1 = this.queryKeywords();
      let promise2 = this.queryTotalCount();
      
      Promise.all([promise1, promise2]).finally(() => {
        this.searching = false
      })
    },
    queryKeywords () {
      axios
        .get("api/Keyword", {
          params: this.filters
        })
          .then(response => {
            this.categories = response.data;
          })
          .finally(() => {
            this.dataLoaded = true
          })
    },
    queryTotalCount () {
      axios
        .get("api/Keyword/Count", {
          params: this.filters
        })
          .then(response => {
            this.total = response.data;
          })
    },
    promptEditKeyword(keyword) {
      this.editModalOpened = true;
      this.keywordToDelete = keyword;
      this.keywordName = this.keywordToDelete.Keyword;
    },
    hideEditModal: function() {
      this.editModalOpened = false;
      this.productToDelete = null;
      this.keywordName = ''
    },
    editKeyword () {
      this.saving = true
      axios
        .put(`api/Keyword/${this.keywordToDelete.KeywordId}`, { Name: this.keywordName })
        .then((data) => {
          console.log(data)
          this.searchKeywords();
          this.$notify({
            message: "The keyword was successfully updated",
            icon: "check_circle_outline",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "success"
          });
        })
        .catch(errors => {
          console.log(errors)
          errors.forEach(e => {
            this.$notify({
              message: e,
              icon: "error_outline",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger"
            });
          });
        })
        .finally(() => {
          this.keywordToDelete = null;
          this.editModalOpened = false;
          this.saving = false
          this.keywordName = ''
        });
    },
    promptDeleteKeyword(keyword) {
      this.deleteModalOpened = true;
      this.keywordToDelete = keyword;
    },
    hideDeleteModal: function() {
      this.deleteModalOpened = false;
      this.productToDelete = null;
    },
    deleteKeyword () {
      this.deleting = true
      axios
        .delete(`api/Keyword/${this.keywordToDelete.KeywordId}`)
        .then(() => {
          this.searchKeywords();
          this.$notify({
            message: "The keyword was successfully deleted",
            icon: "check_circle_outline",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "success"
          });
        })
        .finally(() => {
          this.keywordToDelete = null;
          this.deleteModalOpened = false;
          this.deleting = false
        });
    }
  },
  watch: {
    searchQuery() {
      if (this.searchTimeout)
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.searchKeywords();
      }, 500);
    },
    sortBy() {
      this.searchKeywords();
    },
    sortOrder() {
      this.searchKeywords();
    },
    type() {
      this.searchKeywords();
    },
    currentPage() {
      this.searchKeywords();
    },
    perPage() {
      this.searchKeywords();
    }
  }
};
</script>
